import React, { useState, useEffect } from 'react';
import { X, Sparkles, ChevronRight } from 'lucide-react';
import { Button } from './ui/button';
import api from '../services/api';

const FeatureNotifications = () => {
  const [unseen, setUnseen] = useState([]);
  const [currentIdx, setCurrentIdx] = useState(0);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (!token) return;
    api.get('/feature-notifications')
      .then(res => setUnseen(res.data || []))
      .catch(() => {});
  }, []);

  const markSeen = (featureId) => {
    api.post(`/feature-notifications/${featureId}/seen`, {}).catch(() => {});
  };

  const dismissCurrent = () => {
    if (unseen.length === 0) return;
    markSeen(unseen[currentIdx].id);
    if (currentIdx + 1 < unseen.length) {
      setCurrentIdx(currentIdx + 1);
    } else {
      setDismissed(true);
    }
  };

  const dismissAll = () => {
    api.post('/feature-notifications/dismiss-all', {}).catch(() => {});
    setDismissed(true);
  };

  if (dismissed || unseen.length === 0) return null;

  const feature = unseen[currentIdx];

  return (
    <div data-testid="feature-notification-banner" className="bg-gradient-to-r from-cyan-600 to-blue-600 text-white px-4 py-3 flex items-center gap-3 rounded-lg mb-4 shadow-md">
      <Sparkles size={18} className="flex-shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold">{feature.title}</p>
        <p className="text-xs text-cyan-100">{feature.desc}</p>
      </div>
      <div className="flex items-center gap-2 flex-shrink-0">
        <span className="text-xs text-cyan-200">{currentIdx + 1}/{unseen.length}</span>
        {currentIdx + 1 < unseen.length && (
          <Button size="sm" variant="ghost" onClick={dismissCurrent} className="text-white hover:bg-white/20 h-7 px-2" data-testid="feature-notification-next">
            Next <ChevronRight size={14} />
          </Button>
        )}
        <button onClick={dismissAll} className="text-white/70 hover:text-white p-1" data-testid="feature-notification-dismiss">
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default FeatureNotifications;
